import styled from 'styled-components';

import { FontSizes, FontWeights, Text, TextButton, units } from '@calm-web/design-system';
import { InfoOutline } from '@calm-web/icons';

export const Container = styled.div`
	margin-top: ${units(5)};
`;

export const Header = styled(Text).attrs({
	el: 'h3',
	weight: FontWeights.Medium,
	size: FontSizes.lg,
	color: 'black1',
	noMargin: true,
})``;

export const Row = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	margin-bottom: ${units(1)};
	grid-gap: ${units(2)};
`;

export const BodyText = styled(Text).attrs({
	el: 'p',
	weight: FontWeights.Medium,
	size: FontSizes.base,
	color: 'black2',
	noMargin: true,
})``;

export const BodyTextBold = styled(Text).attrs({
	el: 'p',
	weight: FontWeights.Demi,
	size: FontSizes.base,
	color: 'gray8',
	noMargin: true,
})``;

export const BodyTextLink = styled(TextButton).attrs({
	el: 'p',
	size: FontSizes.base,
	noMargin: true,
	weight: FontWeights.Demi,
	hideUnderline: true,
	textColor: 'blue3',
})`
	letter-spacing: 0.4px;
`;

export const SmallText = styled(Text).attrs({
	el: 'p',
	weight: FontWeights.Medium,
	size: FontSizes.sm,
	color: 'gray8',
	noMargin: true,
})`
	margin-top: ${units(1)};
`;

export const RightAlignedContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
`;

export const LeftAlignedContainer = styled.div`
	display: flex;
`;

export const ExplainerInfo = styled(InfoOutline)`
	margin-left: ${units(0.5)};
`;
